import React, { useEffect } from 'react';
import bem from 'utils/bem';
import { useFormikContext } from 'formik';
import Text from 'components/Text';
import { Button } from 'components/Button';
import UserAgreementCheckboxField from 'forms/fields/UserAgreementCheckboxField';
import Icon from 'components/Icon';
import UserFields from './UserFields';
import Summary from './Summary';
import './index.sass'

const { block, el } = bem('payment-card-form');

export default ({ price, ...form }) => {

    const { setFieldValue } = useFormikContext();

    useEffect(() => {
        setFieldValue('price', price);
    }, [ price ])

    return <form className={ block() } onSubmit={ form.handleSubmit }>
        <div className={ el('title') }>
            <Text serif>Покупка карты пополнения баланса</Text>
        </div>
        <div className={ el('fields') }>
            <div className={ el('user-fields') }>
                <UserFields/>
            </div>
            <div className={ el('details') }>
                <Icon name={ 'info' }/>
                <div>
                    <Text tag={ 'div' }>В течение 30 минут после оплаты баланс обновится в личном кабинете в разделе "Профиль".</Text>
                </div>
            </div>
            <div className={ el('summary') }>
                <Summary price={ price }/>
            </div>
            <div className={ el('footer') }>
                <UserAgreementCheckboxField name='acceptConditions'/>
                <Button
                    type={ 'submit' }
                    mod='gold'
                    disabled={ form.isSubmitting }>
                    Оплатить
                </Button>
            </div>
        </div>
    </form>
}
